// extracted by mini-css-extract-plugin
export default {"body":"table_body__ntmyV","btnContainer":"table_btnContainer__++Gp4","btn":"table_btn__Bqzz+"};